import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MainTheme, _StrategicObjetive, _TransversalSkill } from "../../../../core/services/dataBean/EntityCatalog";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { TransversalSkillTypeEditor } from "../TransversalSkillType/TransversalSkillType.editor";
import { TechnicalCriteria } from "../TechnicalCriteria/TechnicalCriteria";
import { TransversalSkillProduct } from "../TransversalSkillProduct/TransversalSkillProduct";

export const TransversalSkill = () => {

    const TransversalSkill = useDataBean(_TransversalSkill);

    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [modalCri, setModalCri] = useState<any>({ name: 'Criterios de Desempeño', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalPro, setModalPro] = useState<any>({ name: 'Productos del Desempeño', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [transversalskilltype, setTransversalskilltype] = useState<number>(null)
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        getLista();
    }, [transversalskilltype])

    const getLista = () => {

        TransversalSkill.instance.getTransversalSkillCatalog(transversalskilltype).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        TransversalSkill.setBean({

            IDTransversalSkillType: transversalskilltype
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        TransversalSkill.instance.deleteTransversalSkill(TransversalSkill.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
       //console.log(TransversalSkill.bean);
        TransversalSkill.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDTransversalSkill', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Evidencia', property: 'Evidence ', visible: true },
        { title: ' Criterio de Desempeño', property: 'PerformanceCriteria', visible: true },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Productos del Desempeño', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalPro({ ...modalPro, "view": true }) } },
            { titulo: 'Criterios de Desempeño', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalCri({ ...modalCri, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo=" Competencias Transversales">
            <div className="row">
                <div className="col-md-6">
                    <TransversalSkillTypeEditor idSelector={transversalskilltype} onChange={(e) => { setTransversalskilltype(e) }} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={TransversalSkill.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-6">
                                <label>Evidencia</label>
                                <input type="text" name="Evidence" className="form-control" value={TransversalSkill.bean.Evidence} onChange={TransversalSkill.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Criterio de Desempeño</label>
                                <textarea name="PerformanceCriteria" className="form-control" value={TransversalSkill.bean.PerformanceCriteria} onChange={TransversalSkill.handleChange} />
                            </div>

                            <div className="col-md-12">
                                <label>Descripción</label>

                                <textarea name="Description" className="form-control" value={TransversalSkill.bean.Description} onChange={TransversalSkill.handleChange} />
                            </div>



                        </div>
                    </Modal>
                    <Modal modal={modalCri} updateModal={setModalCri} eventModal={editaItem}>
                        <TechnicalCriteria IDTransversalSkill={TransversalSkill.bean.IDTransversalSkill} />
                    </Modal>
                    <Modal modal={modalPro} updateModal={setModalPro} eventModal={editaItem}>
                        <TransversalSkillProduct IDTransversalSkill={TransversalSkill.bean.IDTransversalSkill} />
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}